import React, { useState } from "react";

const Questions = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      className="faq-section animated"
      onMouseEnter={toggleAccordion}
      onMouseLeave={toggleAccordion}
    >
      <div
        className={`faq-header ${isOpen ? "open" : ""}`}
        onClick={toggleAccordion}
      >
        <div className="faq-question">
          How experienced are your virtual assistants?
        </div>
        {/* <div
          className="faq-icon"
          style={{ fontSize: "40px", paddingRight: "20px" }}
        >
          {isOpen ? "-" : "+"}
          <FontAwesomeIcon icon="fa-circle-question" color="black" />
        </div> */}
      </div>
      {isOpen && (
        <div className="faq-answer">
          <span>
            Our virtual assistants possess extensive expertise within their
            specialized domains. In addition, we conduct ongoing training and
            upskilling initiatives to ensure our virtual assistants remain
            well-prepared to proficiently tackle any tasks necessitating support
            in your business.
          </span>
        </div>
      )}
    </div>
  );
};

export default Questions;
